import { SerializableParam, selectorFamily, useRecoilValue } from 'recoil';
import { DocumentService } from 'services';
import { isAuthenticated, refreshState, useSetRefreshState, uploadedDocumentList } from 'state';
import { AttachedDocument } from 'types';

type DocumentParams = {
    disputeNumber: string
} & SerializableParam;

type FilteredDocumentParams = {
    dotProvided: boolean,
} & DocumentParams;

export const disputeDocuments = selectorFamily<AttachedDocument[], DocumentParams>({
    key: 'disputeDocuments',
    get: ({ disputeNumber }) =>
        async ({ get }) => {
            get(refreshState(disputeDocuments({ disputeNumber }).key))
            if (get(isAuthenticated)) {
                const service = new DocumentService();
                const data = await service.getDisputeDocumentsMetadata(disputeNumber);
                return data;
            }
            return [];
        }
});

export const filteredDocuments = selectorFamily<AttachedDocument[], FilteredDocumentParams>({
    key: 'filteredDocuments',
    get: ({ disputeNumber, dotProvided })=>
        async ({ get }) => {
            const documents = get(disputeDocuments({ disputeNumber }));
            const uploadedDocs = get(uploadedDocumentList);
            const dotProvidedDocument = dotProvided ? "True" : "False";

            if (uploadedDocs && uploadedDocs.disputeNumber === disputeNumber) {
                return documents.concat(uploadedDocs.documents.filter(uploadedDocument => 
                    !documents.some(document => document.documentName === uploadedDocument.documentName)
                )).filter(doc => doc.tags["dotProvidedDocument"] === dotProvidedDocument);
            }

            return documents.filter(doc => doc.tags["dotProvidedDocument"] === dotProvidedDocument);
        }

});

export const useDisputeDocuments = (disputeNumber: string) =>  useRecoilValue(disputeDocuments({ disputeNumber }));
export const useDotDocuments =  (disputeNumber: string) => useRecoilValue(filteredDocuments({ disputeNumber, dotProvided: true }))
export const useSupplierDocuments = (disputeNumber: string) => useRecoilValue(filteredDocuments({ disputeNumber, dotProvided: false }))

export const useRefreshDisputeDocuments = (disputeNumber: string) => useSetRefreshState(disputeDocuments({ disputeNumber }));